import type { LineItemExtended } from '~~/types/product/LineItemExtended';

export default function (lineItems: LineItemExtended[]): boolean {

  return lineItems.some(({ volumeDiscountsForGroup, quantity }) => {

    const minimalAmountOfItemsToActivateVolumeDiscount = volumeDiscountsForGroup?.[0]?.volume;

    return minimalAmountOfItemsToActivateVolumeDiscount !== undefined &&
    quantity >= minimalAmountOfItemsToActivateVolumeDiscount;
  
  });

}
